import { render, staticRenderFns } from "./caseselect.vue?vue&type=template&id=3b01371c&scoped=true"
import script from "./caseselect.vue?vue&type=script&lang=js"
export * from "./caseselect.vue?vue&type=script&lang=js"
import style0 from "./caseselect.vue?vue&type=style&index=0&id=3b01371c&prod&lang=less&scoped=true"
import style1 from "./caseselect.vue?vue&type=style&index=1&id=3b01371c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01371c",
  null
  
)

export default component.exports